import { Link } from "react-router-dom";
import { KindredMark } from "./KindredMark";
import { AmbientBackground } from "./AmbientBackground";

const FOUNDING_PAYPAL_URL = "https://www.paypal.com/ncp/payment/KYERFXL4ZYLL8";

const PaymentSuccessPage = () => {
  return (
    <div className="dark-landing relative flex min-h-screen items-center justify-center overflow-x-clip bg-obsidian px-6 text-cream" data-testid="payment-success-page">
      <AmbientBackground />
      <div className="relative z-[1] mx-auto max-w-lg py-24 text-center">
        <Link to="/" className="mb-12 inline-flex items-center gap-2.5" data-testid="payment-success-logo">
          <KindredMark className="h-8 w-8" />
          <span className="font-serif text-xl">Community Hearts</span>
        </Link>
        <h1 className="font-serif text-4xl leading-tight tracking-tight md:text-5xl">
          Founding membership is paid <span className="italic text-gold">in PayPal.</span>
        </h1>
        <p className="mx-auto mt-6 max-w-md text-base leading-relaxed text-cream/60">
          This page does not confirm a card subscription. Use the founding member link to pay, then return to the site.
        </p>
        <a
          href={FOUNDING_PAYPAL_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-glow mt-10 inline-block rounded-full bg-gold px-8 py-4 text-sm font-bold uppercase tracking-[0.15em] text-ink hover:bg-gold-deep active:scale-95"
          data-testid="payment-success-paypal"
        >
          Founding member — Richmond
        </a>
        <Link
          to="/"
          className="mt-4 block text-xs font-bold uppercase tracking-[0.15em] text-cream/50 hover:text-gold"
          data-testid="payment-success-home"
        >
          Back to Community Hearts
        </Link>
      </div>
    </div>
  );
};

export default PaymentSuccessPage;
